import { render } from "./re-authentication-form.vue?vue&type=template&id=10811f06&scoped=true"
import script from "./re-authentication-form.vue?vue&type=script&lang=js"
export * from "./re-authentication-form.vue?vue&type=script&lang=js"

import "./re-authentication-form.vue?vue&type=style&index=0&id=10811f06&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10811f06"]])

export default __exports__